module.exports = __webpack_public_path__ + "static/imperial.0284a1a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/imperial.jpg
// module id = 167
// module chunks = 90313797272492 263200606715368